// extracted by mini-css-extract-plugin
export default {"item":"PlaceholderText_item__tMThy"};